import { render, staticRenderFns } from "./PWResetAuth.vue?vue&type=template&id=2258f436&scoped=true"
import script from "./PWResetAuth.vue?vue&type=script&lang=js"
export * from "./PWResetAuth.vue?vue&type=script&lang=js"
import style0 from "./PWResetAuth.vue?vue&type=style&index=0&id=2258f436&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2258f436",
  null
  
)

export default component.exports